import {
  faClock,
  faFemale,
  faTruckMoving,
  IconDefinition,
  faArrowDownWideShort,
  faCalendar,
  faGift,
  faHeartPulse,
  faHome,
  faHospital,
  faHospitalUser,
  faHouseChimneyMedical,
  faMicroscope,
  faPersonPregnant,
  faSuitcase,
  faSuitcaseMedical,
  faCalendarTime,
  faDoorOpen,
  faFamily,
  faFilesMedical,
  faGaugeCircleMinus,
  faGaugeCirclePlus,
  faGraduationCap,
  faHandshakeAngle,
  faHouseDay,
  faMale,
  faMedkit,
  faPersonCircleQuestion,
  faUserDoctor,
  faAmbulance,
  faBan,
  faQuestion,
} from '@fortawesome/pro-regular-svg-icons';
import { faLeanpub } from '@fortawesome/free-brands-svg-icons';
import { Abwesenheitsgrund } from '@/domain/mitarbeiter/shared/entities/Abwesenheitsgruende';

const iconMap = new Map<Abwesenheitsgrund, IconDefinition>();
iconMap.set('Krank', faSuitcaseMedical);
iconMap.set('Schule', faLeanpub);
iconMap.set('Kurzarbeit', faArrowDownWideShort);
iconMap.set('Quarantaene', faMicroscope);
iconMap.set('QuarantaeneOhneLFZ', faMicroscope);
iconMap.set('Urlaub', faSuitcase);
iconMap.set('UnbezahlterUrlaub', faSuitcase);
iconMap.set('KrankesKind', faPersonPregnant);
iconMap.set('KrankImFrei', faHouseChimneyMedical);
iconMap.set('Krankengeld', faHeartPulse);
iconMap.set('KrankInKurzarbeit', faArrowDownWideShort);
iconMap.set('EURente', faHospitalUser);
iconMap.set('Frei', faHome);
iconMap.set('Wunschfrei', faHouseDay);
iconMap.set('KrankOhneLohnfortzahlung', faFilesMedical);
iconMap.set('Kur', faHospital);
iconMap.set('FeiertagsausgleichDynamisch', faCalendar);
iconMap.set('Feiertagsausgleich', faCalendar);
iconMap.set('Sonderurlaub', faGift);
iconMap.set('Ueberstundenabbau', faCalendarTime);
iconMap.set('Elternzeit', faFamily);
iconMap.set('Mutterschutz', faFemale);
iconMap.set('GuttagPlus', faGaugeCirclePlus);
iconMap.set('GuttagMinus', faGaugeCircleMinus);
iconMap.set('Freistellung', faDoorOpen);
iconMap.set('Wiedereingliederung', faHandshakeAngle);
iconMap.set('Arbeitsunfall', faAmbulance);
iconMap.set('Beschaeftigungsverbot', faBan);
iconMap.set('Lehrgang', faGraduationCap);
iconMap.set('UnbezahlterFerientag', faSuitcase);
iconMap.set('Feiertag', faCalendar);
iconMap.set('Ruhetag', faHome);
iconMap.set('Unfall', faMedkit);
iconMap.set('MilitaerZivildienst', faTruckMoving);
iconMap.set('Mutterschaft', faFemale);
iconMap.set('Vaterschaft', faMale);
iconMap.set('Bildung', faLeanpub);
iconMap.set('BezahlterArbeitsfreierTag', faCalendar);
iconMap.set('Kompensationstag', faCalendar);
iconMap.set('Ausgleichsruhezeitentag', faClock);
iconMap.set('Arztbesuch', faUserDoctor);
iconMap.set('FehltUnentschuldigt', faPersonCircleQuestion);

export function mapAbwesenheitsGrundToIcon(grund: Abwesenheitsgrund) {
  console.log(grund);
  return iconMap.get(grund) || faQuestion;
}
